module.exports = __webpack_public_path__ + "static/media/13.90f59d20.jpg";